module.exports = __webpack_public_path__ + "static/media/lykke09.695d7217.jpg";